var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconAdvancedFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44734_68519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11823 2.5957L0.891194 7.54799C0.864897 7.57297 0.845908 7.60452 0.836866 7.63843L0.2575 9.84149C0.240169 9.90781 0.26074 9.97834 0.311827 10.0267C0.350482 10.0634 0.403151 10.0836 0.457027 10.0836C0.473528 10.0836 0.490407 10.0817 0.506833 10.0778L2.83229 9.52883C2.86853 9.52026 2.90146 9.50235 2.92776 9.47743L8.15524 4.52551L6.11823 2.5957Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44889 1.92116L8.86704 1.36993C8.47816 1.00151 7.80038 1.00187 7.41196 1.36993L6.69922 2.04515L8.73616 3.97488L9.44889 3.29966C9.64315 3.1157 9.75014 2.87085 9.75014 2.61044C9.75014 2.35003 9.64315 2.10518 9.44889 1.92116Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44734_68519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconAdvancedFilter);
export default __webpack_public_path__ + "static/media/editIconAdvancedFilter.917ab49a2bea1f087e2ef1f3a4d155dd.svg";
export { ForwardRef as ReactComponent };